import { render, staticRenderFns } from "./LeadsCardPriceHistoryModal.vue?vue&type=template&id=2a96316c&scoped=true&"
import script from "./LeadsCardPriceHistoryModal.vue?vue&type=script&lang=js&"
export * from "./LeadsCardPriceHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardPriceHistoryModal.vue?vue&type=style&index=0&id=2a96316c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96316c",
  null
  
)

export default component.exports